import {
  UPDATE_MANAGER_HOLIDAY_SUCCESS,
  DELETE_MANAGER_HOLIDAY_SUCCESS,
  ADD_MANAGER_HOLIDAY_SUCCESS
} from "../Constants";

const initialState = {
  message: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_MANAGER_HOLIDAY_SUCCESS:
      return {
        type: "Holidays updated Successfully",
        message: action.data
      };
    case DELETE_MANAGER_HOLIDAY_SUCCESS:
      return {
        type: "Holiday Deleted Successfully",
        message: action.data
      };
    case ADD_MANAGER_HOLIDAY_SUCCESS:
      return {
        type: "Holiday added Successfully",
        message: action.data
      };
    default:
      return state;
  }
};
